import { DateTime } from "luxon";
import {
  OPTION_TACHES_TERMINEES,
  PROCHAINE_TACHE_TERMINE,
} from "../../../../helpers/leadTasksOrder";

const fmtDate = (iso) =>
  iso ? DateTime.fromISO(iso).toFormat("dd/MM/yy") : "";

/**
 * Nombre de filtres actifs (= nombre de jetons). Sert au badge "Filtres".
 * Ne dépend pas du ctx (labels) : on compte juste les champs non vides.
 */
export const countActiveFilters = (filters = {}) => {
  let n = 0;
  if (filters.terms) n += 1;
  if (filters.products?.length) n += 1;
  if (filters.statuses?.length) n += 1;
  if (filters.assignedTo?.length) n += 1;
  if (filters.producer) n += 1;
  if (filters.beginAt || filters.endAt) n += 1;
  if (filters.onlyFinalized) n += 1;
  if (filters.prochaineTache) n += 1;
  return n;
};

/**
 * Construit la liste des jetons affichables à partir des filtres actifs.
 * Chaque jeton : { key, label, clear } où clear = patch à appliquer pour
 * retirer ce filtre (valeur vide).
 * ctx = { userId, managers, LEAD_STATUS, products, producers }
 */
export const buildFilterTokens = (filters, ctx) => {
  const tokens = [];

  if (filters.terms) {
    tokens.push({
      key: "terms",
      label: `« ${filters.terms} »`,
      clear: { terms: "" },
    });
  }

  if (filters.products?.length) {
    const labels = filters.products
      .map((id) => ctx.products?.find((p) => p.id === id)?.id?.toUpperCase() || id)
      .join(", ");
    tokens.push({ key: "products", label: labels, clear: { products: [] } });
  }

  if (filters.statuses?.length) {
    const labels = filters.statuses
      .map((id) => ctx.LEAD_STATUS?.find((s) => s.id === id)?.name || id)
      .join(", ");
    tokens.push({ key: "statuses", label: labels, clear: { statuses: [] } });
  }

  if (filters.assignedTo?.length) {
    const onlyMe =
      filters.assignedTo.length === 1 && filters.assignedTo[0] === ctx.userId;
    let label;
    if (onlyMe) {
      label = "Assigné : moi";
    } else if (filters.assignedTo.length <= 2) {
      label =
        "Assigné : " +
        filters.assignedTo
          .map(
            (id) =>
              ctx.managers?.find((m) => m.id === id)?.fullName || "?",
          )
          .join(", ");
    } else {
      label = `Assigné : ${filters.assignedTo.length} personnes`;
    }
    tokens.push({ key: "assignedTo", label, clear: { assignedTo: [] } });
  }

  if (filters.producer) {
    const label =
      ctx.producers?.find((p) => p.id === filters.producer)?.company ||
      "Société partenaire";
    tokens.push({ key: "producer", label, clear: { producer: "" } });
  }

  if (filters.beginAt || filters.endAt) {
    const label = `${fmtDate(filters.beginAt) || "…"} → ${
      fmtDate(filters.endAt) || "…"
    }`;
    tokens.push({
      key: "period",
      label,
      clear: { beginAt: "", endAt: "" },
    });
  }

  if (filters.onlyFinalized) {
    tokens.push({
      key: "onlyFinalized",
      label: "Finalisés",
      clear: { onlyFinalized: false },
    });
  }

  if (filters.prochaineTache) {
    const label =
      filters.prochaineTache === PROCHAINE_TACHE_TERMINE
        ? OPTION_TACHES_TERMINEES.name
        : "Prochaine : " +
          (ctx.leadTasks?.find((t) => t.id === filters.prochaineTache)?.name ||
            filters.prochaineTache);
    tokens.push({
      key: "prochaineTache",
      label,
      clear: { prochaineTache: "" },
    });
  }

  return tokens;
};
